( function ( $ ) {

    // smooth-scroll / toggle modal on click of id href
    $( document ).on( 'click', 'a[href^="#"]', function ( e ) {
        let $target = $( $(this).attr('href') );
        if ( $target.length ) {
            if ( $target.hasClass('modal') ) {
                e.preventDefault();
                $target.modal('toggle');
                return;
            }
        }
    });

})( jQuery );